/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRemoteSessionClientForm,
  UpdateRemoteSessionClientForm$Outbound,
  UpdateRemoteSessionClientForm$outboundSchema,
} from "../components/updateremotesessionclientform.js";

export type UpdateRemoteSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UpdateRemoteSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UpdateRemoteSessionClientSecurity = {
  option1?: UpdateRemoteSessionClientSecurityOption1 | undefined;
  option2?: UpdateRemoteSessionClientSecurityOption2 | undefined;
};

export type UpdateRemoteSessionClientRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateRemoteSessionClientForm: UpdateRemoteSessionClientForm;
};

/** @internal */
export type UpdateRemoteSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UpdateRemoteSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteSessionClientSecurityOption1$Outbound,
    UpdateRemoteSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateRemoteSessionClientSecurityOption1ToJSON(
  updateRemoteSessionClientSecurityOption1:
    UpdateRemoteSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    UpdateRemoteSessionClientSecurityOption1$outboundSchema.parse(
      updateRemoteSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UpdateRemoteSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UpdateRemoteSessionClientSecurityOption2$Outbound,
    UpdateRemoteSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function updateRemoteSessionClientSecurityOption2ToJSON(
  updateRemoteSessionClientSecurityOption2:
    UpdateRemoteSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    UpdateRemoteSessionClientSecurityOption2$outboundSchema.parse(
      updateRemoteSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionClientSecurity$Outbound = {
  Option1?: UpdateRemoteSessionClientSecurityOption1$Outbound | undefined;
  Option2?: UpdateRemoteSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UpdateRemoteSessionClientSecurity$outboundSchema: z.ZodMiniType<
  UpdateRemoteSessionClientSecurity$Outbound,
  UpdateRemoteSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => UpdateRemoteSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => UpdateRemoteSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function updateRemoteSessionClientSecurityToJSON(
  updateRemoteSessionClientSecurity: UpdateRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    UpdateRemoteSessionClientSecurity$outboundSchema.parse(
      updateRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type UpdateRemoteSessionClientRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateRemoteSessionClientForm: UpdateRemoteSessionClientForm$Outbound;
};

/** @internal */
export const UpdateRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  UpdateRemoteSessionClientRequest$Outbound,
  UpdateRemoteSessionClientRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateRemoteSessionClientForm: UpdateRemoteSessionClientForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      updateRemoteSessionClientForm: "UpdateRemoteSessionClientForm",
    });
  }),
);

export function updateRemoteSessionClientRequestToJSON(
  updateRemoteSessionClientRequest: UpdateRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    UpdateRemoteSessionClientRequest$outboundSchema.parse(
      updateRemoteSessionClientRequest,
    ),
  );
}
